import React, { useMemo, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Stack } from "@mui/material"
import PSEPreparation from "../preview/PSEPreparation"
import PSEStepComponents from "../preview/PSEStepComponents"
import { getProductionStepsKitchenAreaSelector, getPSESectionSelector } from "../../../reducers/Production/ProductionSteps"
import { loadPSEMachinesOptions } from "../../../actions/ProductionSteps/ProductionStepExecutions"
import PSEWeights from "../preview/PSEWeights"
import PSECookingRecap from "../preview/PSECookingRecap"
import PSECoolingRecap from "../preview/PSECoolingRecap"
import PSESectionOuptutRecap from "../preview/PSESectionOuptutRecap"

const ProductionStepExecutionInsufficientWeight = ({ productionStepExecution }) => {
	const dispatch = useDispatch()
	const transformationType = useMemo(() => productionStepExecution.productionStepSnapshot.transformation, [productionStepExecution])
	const kitchenArea = useSelector(getProductionStepsKitchenAreaSelector)
	const pseSection = useSelector(getPSESectionSelector)

	const _loadMachinesOptions = (productionStepExecution, kitchenAreaId) => {
		dispatch(loadPSEMachinesOptions({ productionStepExecution, kitchenAreaId }))
	}

	useEffect(() => {
		if (transformationType === "COOLING" && kitchenArea && productionStepExecution) {
			_loadMachinesOptions(productionStepExecution, kitchenArea.objectId)
		}
	}, [productionStepExecution, transformationType, kitchenArea])

	return (
		<Stack spacing={3} sx={{ p: 3 }}>
			<PSEPreparation productionStepExecution={productionStepExecution} />
			<PSEWeights
				productionStepExecution={productionStepExecution}
				status={productionStepExecution.status}
				isVisible
			/>
			{productionStepExecution.isSectionLastStep && pseSection?.sectionOutputs && pseSection.sectionOutputs.length > 0 && <PSESectionOuptutRecap productionStepExecution={productionStepExecution} />}
			<PSECookingRecap
				visible={transformationType === "COOKING"}
				machinesBatch={productionStepExecution.machinesBatch}
			/>
			<PSECoolingRecap
				visible={transformationType === "COOLING"}
				machinesBatch={productionStepExecution.machinesBatch}
				pseId={productionStepExecution.objectId}
			/>
			<PSEStepComponents
				stepComponents={productionStepExecution.productionStepSnapshot.stepComponents}
				substitutes={productionStepExecution.substitutes}
				productionStepExecution={productionStepExecution}
				expectedProduction={productionStepExecution.expectedProduction}
				coeff={productionStepExecution.coeff}
				isReusableStep={!!productionStepExecution.reusableProductionStep}
				theoreticalGrossWeight={productionStepExecution.theoreticalGrossWeight}
			/>
		</Stack>
	)
}

export default ProductionStepExecutionInsufficientWeight